import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

// iPhone/iPad (incl. iPadOS that reports as Mac) can't scroll multi-page PDFs inside iframes
export const isIOS = () =>
  typeof navigator !== "undefined" &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));

export const PDF_MAX_MB = 25;

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
